import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { CompanyData } from "./CompanyData";
import {
  Card as BaseCard,
  ElementContainer,
  RowContainer,
} from "../../components/containers/styledComponents";
import { companyTabElements as companyTabElementsBase } from "./constants";
import {
  CompanySummary,
  CompanyTabTitle,
} from "../../models/CompanyprofileModels";
import { CompanyDescription } from "./CompanyDescription";

import { MESSAGES } from "../../messages";
import {
  TabElement,
  TabOptions,
} from "../../components/visuals/TabOptions/TabOptions";
import { CompanyNZA } from "./NetZeroAssessment/CompanyNZA";
import { CompanyEnvironmentalProfile } from "./EnvironmentalProfile/CompanyEnvironmentalProfile";

const Card = styled(BaseCard)`
  min-height: 150px;
`;

export const CompanyTabBar = ({ data }: CompanyTabBarProps): JSX.Element => {
  const [companyTabElements, setCompanyTabElements] = useState<TabElement[]>(
    []
  );

  const isLoading = !!!companyTabElements.length;

  useEffect(() => {
    if (data) {
      setCompanyTabElements(companyTabElementsBase);
    }
  }, [data]);

  const findActiveTab = (): string => {
    return (
      companyTabElements.find((tabElement) => tabElement.isActive)?.title ||
      companyTabElementsBase[0].title
    );
  };

  // Function to render the appropriate component
  const getSelectedTabComponent = (title: string): JSX.Element => {
    switch (title) {
      case CompanyTabTitle.CompanyDescription:
        return (
          <CompanyDescription
            description={
              isLoading
                ? null
                : data?.description_fmp || MESSAGES.NOT_AVAILABLE_TEXT
            }
          />
        );
      case CompanyTabTitle.CompanyData:
        return <CompanyData {...(data as CompanySummary)} />;
      case CompanyTabTitle.NetZeroAssessment:
        return <CompanyNZA companyId={data?.compass_cid || ""} />;
      case CompanyTabTitle.EnvironmentalProfile:
        return (
          <CompanyEnvironmentalProfile companyId={data?.compass_cid || ""} />
        );
      default:
        return (
          <CompanyDescription
            description={
              isLoading
                ? null
                : data?.description_fmp || MESSAGES.NOT_AVAILABLE_TEXT
            }
          />
        );
    }
  };

  return (
    <RowContainer ml={10} mt={1} ai="center">
      <Card
        w={100}
        h={"auto"}
        m="0 30px 0 10px"
        p={"8px"}
        isLoading={isLoading}
      >
        <ElementContainer flexDirection="row" ai="center">
          <TabOptions
            tabElements={companyTabElements}
            setTabElements={setCompanyTabElements}
          />
        </ElementContainer>
        {getSelectedTabComponent(findActiveTab())}
      </Card>
    </RowContainer>
  );
};

type CompanyTabBarProps = {
  data: CompanySummary | null;
};
